// Utils
import { component } from 'picoapp';

import { setCSSProperty } from 'utils/css';

import choozy from 'utils/choozy';

// Constants
const CSS_TRANSITION_SPEED = '--transition-speed';
const CSS_Y_OFFSET = '--y-offset';

export default component((node) => {
  const { increment, decrement, input, valueLabel } = choozy(node);

  const valueLabels = [].concat(valueLabel);

  const min = parseInt(node.dataset.min, 10);
  const max = parseInt(node.dataset.max, 10);

  let value = parseInt(input.value, 10);
  let yOffsets = [0, 100];

  const transition = (origin = 'bottom') => {
    const activeIndex = valueLabels[yOffsets.indexOf(0)];
    const inactiveIndex = valueLabels[yOffsets.indexOf(100)];

    inactiveIndex.textContent = value;
    input.value = value;

    setCSSProperty(node, CSS_TRANSITION_SPEED, '0s');
    setCSSProperty(inactiveIndex, CSS_Y_OFFSET, origin === 'bottom' ? '100%' : '-100%');

    setTimeout(() => {
      setCSSProperty(node, CSS_TRANSITION_SPEED, '.6s');
      setCSSProperty(activeIndex, CSS_Y_OFFSET, origin === 'bottom' ? '-100%' : '100%');
      setCSSProperty(inactiveIndex, CSS_Y_OFFSET, '0%');
    }, 0);

    yOffsets = yOffsets.reverse();
  };

  const update = () => {
    input.setAttribute('data-old-value', parseInt(input.value, 10));
    increment.disabled = value === max;
    decrement.disabled = value === min;
  };

  const emitChangeEvent = (oldValue) => {
    const event = new CustomEvent('quantity:change', {
      cancelable: true,
      bubbles: true,
      detail: {
        value,
        oldValue,
      },
    });

    node.dispatchEvent(event);
  };

  increment.addEventListener('click', () => {
    const { oldValue } = input.dataset;

    value += 1;
    transition('bottom');
    emitChangeEvent(+oldValue);
    update();
  });

  decrement.addEventListener('click', () => {
    const { oldValue } = input.dataset;

    value -= 1;
    transition('top');
    emitChangeEvent(+oldValue);
    update();
  });

  // Event listener for input
  input.addEventListener('change', (e) => {
    const { oldValue } = input.dataset;
    const activeIndex = valueLabels[yOffsets.indexOf(0)];
    const targetValue = Math.min(Math.max(parseInt(e.target.value, 10), min), max);

    input.value = targetValue;

    if (targetValue === value) return;

    value = targetValue;
    activeIndex.textContent = value;

    update();
    emitChangeEvent(+oldValue);
  });

  node.addEventListener('set', (e) => {
    value = e.detail.value;

    const activeIndex = valueLabels[yOffsets.indexOf(0)];

    input.value = value;
    activeIndex.textContent = value;

    update();
  });

  // Initialize
  update();
});
